import { render, staticRenderFns } from "./DoubleSyncModal.vue?vue&type=template&id=2463f507&scoped=true"
import script from "./DoubleSyncModal.vue?vue&type=script&lang=js"
export * from "./DoubleSyncModal.vue?vue&type=script&lang=js"
import style0 from "./DoubleSyncModal.vue?vue&type=style&index=0&id=2463f507&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2463f507",
  null
  
)

export default component.exports